import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import CustomAppBar from "./AppBar";
import Sidebar from "./Sidebar";
import AssistantChat from "./AssistantChat";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import DashboardIcon from "@mui/icons-material/Dashboard";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import FlakyIcon from "@mui/icons-material/Flaky";
import HubIcon from "@mui/icons-material/Hub";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
const navItems = [
  { text: "Dashboard", link: "/", icon: <DashboardIcon /> },
  { text: "Cases", link: "/cases", icon: <BusinessCenterIcon /> },
  { text: "Suites", link: "/suites", icon: <FlakyIcon /> },
  { text: "Agents", link: "/agents", icon: <PrecisionManufacturingIcon /> },
  { text: "Artifacts", link: "/artifacts", icon: <HubIcon /> },
  { text: "Coverage", link: "/coverage", icon: <FactCheckOutlinedIcon /> },
];

const MainLayout = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [mobileOpen, setMobileOpen] = useState<boolean>(false);

  const handleDrawerOpen = () => setMobileOpen(true);
  const handleToggle = () => setMobileOpen(!mobileOpen);

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <CustomAppBar handleDrawerOpen={handleDrawerOpen} />
      <Sidebar
        open={isDesktop ? true : mobileOpen}
        handleToggle={handleToggle}
        navItems={navItems}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          p: { xs: 1.5, sm: 2, md: 3 },
          mt: { xs: "56px", sm: "64px" },
          height: { xs: "calc(100vh - 56px)", sm: "calc(100vh - 64px)" },
          overflow: "auto",
          backgroundColor: "#f6f7f9",
          backgroundImage:
            "linear-gradient(180deg, rgba(255,255,255,0.85) 0%, rgba(246,247,249,0) 220px)",
        }}
      >
        <Outlet />
      </Box>
      <AssistantChat />
    </Box>
  );
};

export default MainLayout;
